export default "__VITE_ASSET__97f2f184__"